import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ScrollTriggerをGSAPに登録
gsap.registerPlugin(ScrollTrigger);

export function underTopMove() {
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
      // GSAPのタイムラインを作成
      const tl = gsap.timeline();

      // 画像の初期設定とアニメーション
      tl.fromTo(
        ".js-under-top__img",
        {
          x: "100%", // 初期位置：右側の画面外
          visibility: "visible", // 初期表示
        },
        {
          duration: 2, // アニメーションの持続時間
          x: 0, // 終了位置：画面の中央
          ease: "power2.inOut",
        }
      )
        // 文字の初期設定とアニメーション
        .fromTo(
          ".js-under-top__text",
          {
            y: "30%", // 初期位置：下側の画面外
            visibility: "visible", // 初期表示
            opacity: 0,
          },
          {
            duration: 1, // アニメーションの持続時間
            y: 0, // 終了位置：画面の中央
            opacity: 1,
            // ease: "power2.inOut",
            ease: "back.out(1.7)",
          },
          "-=0.8" // 画像のアニメーションが終わる0.8秒前に開始
        );
    }, 1000);
  });
}
